import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaSituazioneEconomicaEditComponent.vue?vue&type=template&id=77498582"
import script from "./RsaSchedaRelazioneSanitariaSituazioneEconomicaEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaSituazioneEconomicaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports